import axiosClient from "utils/api";
const URI = "/admin/announcement";

export const sendAnnouncement = async (payload) => {
  const URL = `${URI}`;
  try {
    const response = await axiosClient().request({
      url: URL,
      method: "post",
      data: payload,
    });
    return response.data;
  } catch (error) {
    console.error("Error occurred during send announcement:", error);
    throw error;
  }
};

export const getAnnouncement = async (payload) => {
  const URL = `${URI}`;
  try {
    const response = await axiosClient().request({
      url: URL,
      method: "get",
      params: payload,
    });
    return response.data;
  } catch (error) {
    console.error("Error occurred during get announcement:", error);
    throw error;
  }
};

export const getAnnouncementUserList = async (payload) => {
  const { id, ...rest } = payload;
  const URL = `${URI}/${id}`;
  try {
    const response = await axiosClient().request({
      url: URL,
      method: "get",
      params: rest,
    });
    return response.data;
  } catch (error) {
    console.error("Error occurred during get announcement user list:", error);
    throw error;
  }
};
